import { Formik, Form } from 'formik';
import React from 'react';

const FormikWrapper = ({ initialValues, handleSubmit, validationSchema, children, id }) => {
    return (
        <Formik
            initialValues={initialValues}
            onSubmit={values => handleSubmit(values)}
            validationSchema={validationSchema}
            key={id}
        >
            {() => <Form>{children}</Form>}
        </Formik>
    );
};

export default FormikWrapper;
